<template>
    <div class="wizard-launcher">
        <button
            :disabled="disabled"
            class="ai-convert-button"
            type="button"
            @click="openWizard">
            <i class="fa fa-magic button-icon"></i>
            <span>{{ buttonText }}</span>
        </button>

        <convert-ivr-wizard
            :key="wizardKey"
            :visible="wizardVisible"
            :ivr-id="ivrId"
            :campaign-id="campaignId"
            @close="closeWizard"
            @conversion-complete="handleConversionComplete"
        />
    </div>
</template>

<script>
import ConvertIvrWizard from '../../views/iva-wizard/convert-ivr.vue'

export default {
    name: 'WizardLauncher',

    components: {
        ConvertIvrWizard
    },

    props: {
        ivrId: {
            type: Number,
            required: true
        },
        campaignId: {
            type: Number,
            default: null
        },
        buttonText: {
            type: String,
            default: 'Convert to IVA'
        },
        size: {
            type: String,
            default: 'small'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            wizardVisible: false,
            wizardKey: 0
        }
    },

    methods: {
        openWizard(event) {
            // Prevent any default behavior
            if (event) {
                event.preventDefault()
                event.stopPropagation()
            }
            
            // Increment key to force wizard re-render and re-run analysis
            this.wizardKey++
            this.wizardVisible = true
        },

        closeWizard() {
            this.wizardVisible = false
        },

        handleConversionComplete(data) {
            this.$emit('conversion-complete', data)
        }
    }
}
</script>

<style scoped>
.wizard-launcher {
    display: inline-block;
    position: relative;
}

.ai-convert-button {
    background: linear-gradient(to right, #2563EB, #9333EA);
    border: none;
    border-radius: 6px;
    box-shadow: 0 4px 15px 0 rgba(37, 99, 235, 0.35);
    transition: all 0.3s ease;
    color: white;
    font-weight: 600;
    font-size: 13px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    padding: 10px 20px;
    cursor: pointer !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    outline: none;
    pointer-events: auto !important;
    position: relative;
    z-index: 10;
    white-space: nowrap;
    min-width: fit-content;
}

.ai-convert-button:hover {
    background: linear-gradient(to right, #1d4ed8, #7e22ce);
    transform: translateY(-1px);
    box-shadow: 0 6px 20px 0 rgba(37, 99, 235, 0.45);
}

.ai-convert-button:active {
    transform: translateY(0);
    background: linear-gradient(to right, #1e40af, #6b21a8);
}

.ai-convert-button:disabled {
    opacity: 0.6;
    cursor: not-allowed !important;
    pointer-events: none;
}

.button-icon {
    margin-right: 7px;
    font-size: 14px;
    pointer-events: none;
    color: white;
}

.ai-convert-button span {
    color: white;
    pointer-events: none;
    line-height: 1;
}
</style>
